import { useQuery } from '@tanstack/react-query';
import { fetchRecommendationById, fetchRecommendations } from './api';

export const recommendationsQueryKey = 'recommendations';

export const useRecommendationsQuery = (enabled: boolean = true) =>
  useQuery({
    queryKey: [recommendationsQueryKey],
    queryFn: fetchRecommendations,
    enabled,
  });

export const useRecommendationByIdQuery = (recommendationId?: string) =>
  useQuery({
    queryKey: [recommendationsQueryKey, recommendationId],
    queryFn: () => fetchRecommendationById(recommendationId ?? ''),
    enabled: Boolean(recommendationId),
  });
